import { defineAction } from '~/prix'
import { z } from 'zod'
import semenStockCreateAction from './semenStockCreate.action.json' with { type: 'json' }
import { semenStockObject } from '../semenStockObject'

const semenStockCreateDefinition = defineAction({
  ...semenStockCreateAction,

  input: semenStockObject
    .pick({
      id: true,
      bullId: true,
      quantity: true,
      type: true,
      buyDate: true,
      noteNumber: true,
      supplier: true,
      semenType: true,
      semenBatchId: true,
      unityValue: true,
    })
    .partial({ id: true }),
  output: z.object({ id: semenStockObject.shape.id }),
})

export default semenStockCreateDefinition
